import { isEmpty } from 'lodash';

export function transformSupportedStatesForUI(payload) {
  if (isEmpty(payload) || isEmpty(payload.data)) {
    return [];
  }

  return payload.data;
}
